import { render, staticRenderFns } from "./TheHeaderDropdownNotif.vue?vue&type=template&id=0c7ca1f6&scoped=true&"
import script from "./TheHeaderDropdownNotif.vue?vue&type=script&lang=js&"
export * from "./TheHeaderDropdownNotif.vue?vue&type=script&lang=js&"
import style0 from "./TheHeaderDropdownNotif.vue?vue&type=style&index=0&id=0c7ca1f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7ca1f6",
  null
  
)

export default component.exports